import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';
import { PostSubmissionFormContainer } from './form-pagination.styled';
import { defaultUserCustomTexts } from '../../../shared/form-lib';

const FormSubmitError = (props) => {
  const { submitError, canSeeFormBack, showFilledForm, formFont, userCustomTexts} = props;
  return (
    <PostSubmissionFormContainer error>
      <SubmitError style={{ '--font-family': formFont }}>
        <img src="https://storage.googleapis.com/fplsblog/error-icon.svg" alt="error" />
        <h1>Oops!</h1>
        <div id="message">
          <h2>{userCustomTexts?.post_submit_error || defaultUserCustomTexts.post_submit_error}</h2>
          <p dangerouslySetInnerHTML={{ __html: submitError }} />
          {canSeeFormBack && (
            <p>{userCustomTexts?.more_post_submit_error || defaultUserCustomTexts.more_post_submit_error} </p>
          )}
          <p>
            If the issue persists, please contact the form owner or{' '}
            <a href="https://help.formpl.us/s/">send us a support ticket</a>
          </p>
        </div>
        <div id="action">
          <button id="reload" onClick={() => window.location.reload()}>
            Reload Form
          </button>
          {canSeeFormBack && (
            <button id="review" onClick={showFilledForm}>
              View Form
            </button>
          )}
        </div>
      </SubmitError>
    </PostSubmissionFormContainer>
  );
};

export default FormSubmitError;

FormSubmitError.propTypes = {
  submitError:  PropTypes.string.isRequired,
  canSeeFormBack: PropTypes.bool.isRequired,
  showFilledForm: PropTypes.func.isRequired,
  formFont: PropTypes.string.isRequired,
  userCustomTexts: PropTypes.any.isRequired,
}

const SubmitError = styled.div`
  width: 90%;
  max-width: 550px;
  text-align: center;
  margin: 100px 0;

  > img {
    height: 100px;
    width: 100px;

    @media screen and (min-width: 768px) {
      height: 120px;
      width: 120px;
    }
  }

  > h1 {
    font-size: 54px;
    font-weight: 300;
    margin: 0;
    margin-top: -30px;
    color: #ed4c5c;

    @media screen and (min-width: 768px) {
      font-size: 64px;
      margin-top: -40px;
    }
  }

  > #message {
    margin-top: 50px;
    font-family: var(--font-family);

    h2 {
      text-align: center;
    }

    > p {
      font-weight: 500;
      font-size: 18px;
      text-align: justify;

      > a {
        color: #00afbf;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  > #action {
    width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    > button {
      flex: 1;
      padding: 12px 5px;
      outline: none;
      font-family: var(--font-family);
      font-size: 16px;
      font-weight: 600;
      border: 1px solid;
      border-radius: 2px;
      cursor: pointer;
      transition: 300ms;

      &#reload {
        background-color: #fff;
        color: #00afbf;
        :hover {
          background-color: #f5fdfd;
        }
      }

      &#review {
        background-color: #1a8caf;
        color: white;
        :hover {
          filter: brightness(0.8);
        }
      }
    }
  }
`;
